<template>
  <Modal
    :id="'cmp-booking-booking-booking_request booking-request'"
    @cancelled="onCancelClick"
  >
    <template slot="header">
      <span style="padding-left: 8px">{{ $t("add") }} {{ $t("booking") }}</span>
    </template>
    <template slot="body">
      <v-tabs
        :value="activeTab"
        class="dt-hide-tabbar"
        :class="{
          'dt-loading': loading,
        }"
      >
        <v-tab v-for="n in tabs" :key="n.value" ripple>
          {{ n.text }}
        </v-tab>
        <v-tab-item>
          <div class="dt-modal--subtitle">{{ $t("basic_setup") }}</div>
          <div class="box-body" v-if="cdate">
            <v-layout row wrap class="tab-content">
              <v-flex md6 class="half-container">
                <div class="form-group">
                  <BasicInfo
                    :cdate="cdate"
                    :statuses="statuses"
                    :countries="countries"
                    :customFieldKeys="customFieldKeys"
                    @changed="onBasicInfoChanged"
                  />
                </div>
              </v-flex>
              <v-flex md6 class="half-container artist-side">
                <ArtistInfo
                  v-for="artist of cdate.artists"
                  :key="artist.artist_id"
                  :artist="artist"
                  @changed="
                    ({ name, value }) => onArtistChange(artist, name, value)
                  "
                />
              </v-flex>
            </v-layout>
          </div>
          <!-- <v-card>
            <v-layout row wrap>
              <v-flex md12 class="box-container">
                <div class="box-widget selected">
                  <div class="box-header gray">
                    <div class="box-header--name">
                      {{ $t("basic_setup") }}
                    </div>
                  </div>
                </div>
              </v-flex>
            </v-layout>
          </v-card> -->
        </v-tab-item>
        <v-tab-item>
          <div class="dt-modal--subtitle">{{ $t("location") }}</div>
          <div class="box-body">
            <v-layout row wrap style="height: 100%">
              <v-flex md6 class="venues dt-list-v3" pa-1>
                <div class="box-widget selected">
                  <div class="box-header gray">
                    <div class="box-header--name">
                      {{ $t("request_venue") }} {{ cdate.venue_name }}
                    </div>
                  </div>
                  <div class="box-body">
                    <VenueInfo
                      :cdate="cdate"
                      :countries="countries"
                      :allDisabled="true"
                    />
                  </div>
                </div>
                <!-- <v-layout 
                  class="venu-item item" 
                  @click="e => onSelectVenue(venue)" 
                  v-for="venue of venues" 
                  :key="venue.booking_location_id" 
                  row wrap>
                  {{venue.booking_location_name}}
                </v-layout> -->
              </v-flex>
              <v-flex md6 class="venues" pa-1>
                <div class="box-widget selected">
                  <div class="box-header gray">
                    <div class="box-header--name">
                      {{ $t("existing_venue") }} {{ cdate.venue_name }}
                    </div>
                  </div>
                  <div class="box-body">
                    <VenueInfo
                      :cdate="cdate"
                      :countries="countries"
                      @changed="onBasicInfoChanged"
                    />
                  </div>
                </div>
              </v-flex>
            </v-layout>
            <div ref="expandedMapContainer"></div>
          </div>
          <!-- <v-card>
            <v-layout row wrap>
              <v-flex md12 class="box-container">
                <div class="box-widget selected">
                  <div class="box-header gray">
                    <div class="box-header--name">
                      {{ $t("location") }}
                    </div>
                  </div>
                </div>
              </v-flex>
            </v-layout>
          </v-card> -->
        </v-tab-item>
        <v-tab-item>
          <div class="dt-modal--subtitle">
            {{ $t("promoter") }} {{ isPromoterTabNextable }}
          </div>

          <div class="box-body">
            <v-layout row wrap style="height: 100%">
              <v-flex md6 class="venues" pa-1>
                <div class="box-widget selected">
                  <div class="box-header gray">
                    <div class="box-header--name">
                      {{ $t("booking_request") }}
                    </div>
                  </div>
                  <div class="box-body">
                    <ContactInfo
                      :contact="cdatePromoterToContact(cdate)"
                      :countries="countries"
                      :allDisabled="true"
                    />
                  </div>
                </div>
              </v-flex>
              <v-flex md6 class="venues" pa-1>
                <div class="box-widget selected">
                  <div class="box-header gray">
                    <div class="box-header--name">
                      {{ $t("existing_promoters") }}
                    </div>
                  </div>
                  <div class="box-body">
                    <template v-if="!selectedPromoter">
                      <div class="ab-entity-search">
                        <InputField
                          :value="promoterSearchString"
                          :placeholder="$t('search') + ' ' + $t('promoter')"
                          :config="{
                            borderStyle: 'around',
                          }"
                          @keyup="onPromoterSearchKeyUp"
                        ></InputField>
                      </div>
                      <div class="dt-list-v3">
                        <div
                          class="item"
                          @click="(e) => onSelectPromoter(promoter)"
                          v-for="promoter of promoters"
                          :key="promoter.contact_id"
                          row
                          wrap
                        >
                          <v-layout row wrap>
                            <v-flex md4 class="txtov">
                              {{ getContactName(promoter) }}
                            </v-flex>
                            <v-flex md4 offset-md4>
                              {{ promoter.country }}
                            </v-flex>
                          </v-layout>
                        </div>
                      </div>
                      <v-layout row wrap pa-1>
                        <button
                          style="width: 100%"
                          class="dt-button s2 v1"
                          @click="onNewPromoterClick"
                        >
                          {{ $t("create") }} {{ $t("new") }}
                          {{ $t("promoter") }}
                        </button>
                      </v-layout>
                    </template>
                    <template v-else>
                      <ContactInfo
                        :contact="selectedPromoter"
                        :countries="countries"
                        @changed="onSelectedPromoterChange"
                      />
                    </template>
                  </div>
                </div>
              </v-flex>
            </v-layout>
          </div>
          <!-- <v-card>
            <v-layout row wrap>
              <v-flex md12 class="box-container">
                <div class="box-widget selected">
                  <div class="box-header gray">
                    <div class="box-header--name">
                      {{ $t("promoter") }} {{ isPromoterTabNextable }}
                    </div>
                  </div>
                </div>
              </v-flex>
            </v-layout>
          </v-card> -->
        </v-tab-item>
        <v-tab-item>
          <div class="dt-modal--subtitle">
            {{ $t("contact") }}
          </div>
          <div class="box-body">
            <v-layout row wrap style="height: 100%">
              <v-flex md6 class="venues" pa-1>
                <div class="box-widget selected">
                  <div class="box-header gray">
                    <div class="box-header--name">
                      {{ $t("request_contact1") }}
                      {{ cdate.contact_first_name }}
                    </div>
                  </div>
                  <div class="box-body">
                    <ContactInfo
                      :contact="cdateContactToContact(cdate)"
                      :countries="countries"
                      :allDisabled="true"
                      :type="'contact'"
                    />
                  </div>
                </div>
              </v-flex>
              <v-flex md6 class="venues" pa-1>
                <div class="box-widget selected">
                  <div class="box-header gray">
                    <div class="box-header--name">
                      {{ $t("existing_contacts") }}
                    </div>
                  </div>
                  <div class="box-body">
                    <template v-if="!selectedContact">
                      <div class="ab-entity-search">
                        <InputField
                          :value="contactSearchString"
                          :placeholder="$t('search') + ' ' + $t('contact')"
                          :config="{
                            borderStyle: 'around',
                          }"
                          @keyup="onContactSearchKeyUp"
                        ></InputField>
                      </div>
                      <div class="dt-list-v3">
                        <div
                          class="item"
                          @click="(e) => onSelectContact(contact)"
                          v-for="contact of contacts"
                          :key="contact.contact_id"
                          row
                          wrap
                        >
                          <v-layout row wrap>
                            <v-flex md4 class="txtov">
                              {{ getContactName(contact) }}
                            </v-flex>
                            <v-flex md4 offset-md4>
                              {{ contact.country }}
                            </v-flex>
                          </v-layout>
                        </div>
                      </div>
                      <v-layout row wrap pa-1>
                        <button
                          style="width: 100%"
                          class="dt-button s2 v1"
                          @click="onNewContactClick"
                        >
                          {{ $t("create") }} {{ $t("new") }}
                          {{ $t("contact") }}
                        </button>
                      </v-layout>
                    </template>
                    <template v-else>
                      <ContactInfo
                        :contact="selectedContact"
                        :countries="countries"
                        :type="'contact'"
                        @changed="onSelectedContactChange"
                      />
                    </template>
                  </div>
                </div>
              </v-flex>
            </v-layout>
          </div>
          <!-- <v-card>
            <v-layout row wrap>
              <v-flex md12 class="box-container">
                <div class="box-widget selected">
                  <div class="box-header gray">
                    <div class="box-header--name">
                      {{ $t("contact") }}
                    </div>
                  </div>
                </div>
              </v-flex>
            </v-layout>
          </v-card> -->
        </v-tab-item>
      </v-tabs>
      <v-layout row wrap mx-2>
        <v-layout style="padding: 20px 3px 0px 3px" md4 offset-md8>
          <v-flex md6>
            <v-layout row wrap justify-start>
              <button
                class="dt-button s2"
                @click="onBackClick"
                :disabled="!isBackButtonEnabled"
                :class="{
                  disabled: !isBackButtonEnabled,
                }"
                :style="{
                  visibility: isBackTabVisible ? 'visible' : 'hidden',
                }"
              >
                {{$t('back')}}
              </button>
              <button class="dt-button s2 v1" @click="onCancelClick">
                {{$t('close')}}
              </button>
            </v-layout>
          </v-flex>
          <v-flex md6>
            <v-layout row wrap justify-end>
              <button
                class="dt-button s2 v1"
                @click="onFinishClick"
                :disabled="!isFinishEnabled || finishLocked"
                :class="{
                  disabled: !isFinishEnabled || finishLocked,
                }"
                :style="{
                  visibility: isFinishButtonVisible ? 'visible' : 'hidden',
                }"
              >
                {{$t('finish')}}
              </button>
              <button
                class="dt-button s2"
                @click="onNextClick"
                :disabled="!isNextButtonEnabled"
                :class="{
                  disabled: !isNextButtonEnabled,
                }"
                :style="{
                  visibility: isNextTabVisible ? 'visible' : 'hidden',
                }"
              >
                {{$t('next')}}
              </button>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-layout>
    </template>
  </Modal>
</template>

<script>
// Remove Output JSON
// Change POST to GET
// Change Searchy By Name Promoter to Search by Email <-- Confused
//
import Modal from "@dtplugins/modal/modal";

import BasicInfo from "../booking-form/basic-info";
import ArtistInfo from "../booking-form/artist-info";
import VenueInfo from "../booking-form/venue-info";
import ContactInfo from "../booking-form/promoter-info";

import { bookingRequestsService } from "../../services/booking-requests.service";
import {
  createCDate,
  cdatePromoterToContact,
  cdateContactToContact,
  contactToCdatePromoter,
  contactToCDateContact,
  createFinishRequest,
} from "../booking-form/cdate.model";
import InputField from "../../../../plugins/text-field/input-field";
import { Subject } from "rxjs";
import { debounceTime, distinctUntilChanged } from "rxjs/operators";
import { BookingService } from "../../services/booking-service";
import { isNil, any, identity } from "ramda";
import { NotificationService } from "../../../../dt-plugins/notification/notification.service";

export default {
  components: {
    Modal,
    InputField,

    BasicInfo,
    ArtistInfo,
    VenueInfo,
    ContactInfo,
  },
  mounted: function () {
    this.loading = true;
    bookingRequestsService
      .getBookingRequest(this.calendarDateId, this.artistIdR)
      .then((res) => {
        console.log("STATUS", res);
        console.log(res.data.cdate, res.data.booking_cf);
        this.bookingData = res.data;

        this.getCustomFieldKeys(res.data.cdate, res.data.booking_cf);

        this.statuses = res.data.statuses;
        this.countries = res.data.countries;

        this.loading = false;

        // If The Client does not have any BOoking Statuses - Undefined or Length is Zero - Then Show this Error Notification
        if (!res.data?.statuses || res.data?.statuses?.length < 1) {
          NotificationService.showNotification({
            text: "Add Status In Settings Booking",
            timeout: 5000,
          });
        }

        let defaultStatus =
          res.data.statuses.find((e) => e.default_status_booking_flag == `1`) ||
          {};
        console.log("defaultStatus", defaultStatus);

        if (!defaultStatus?.booking_status_id) {
          // return;

          defaultStatus =
            res.data?.statuses.find(
              (e) => e.booking_status_name == "cancelled"
            ) || res.data?.statuses?.[0];
          console.log("defaultStatus :::::::", defaultStatus, res.data);
          //defaultStatus = { booking_status_id: "", booking_status_name: "cancelled"}
        }

        const { booking_status_id, booking_status_name } = defaultStatus;

        //console.log(this.customFieldKeys);

        // console.log();

        this.cdate = {
          ...createCDate({
            ...res.data.cdate,
            booking_status_id,
            booking_status_name,
          }),
          ...this.customFieldKeys
            .map((e) => e.cfKey)
            .reduce((accm, cur) => {
              accm[cur] = res.data.cdate[cur];
              return accm;
            }, {}),
        };

        // this.cdate.booking_status_id = defaultStatus.booking_status_id;
        // this.cdate.booking_status_name = defaultStatus.booking_status_name;

        // this.statuses = res.data.statuses;
        // this.countries = res.data.countries;

        // this.loading = false;
      });

    // Venue Subscription

    // this.$subscribeTo(
    //   this.venueSearchSubject$
    //   .asObservable()
    //   .pipe(
    //     debounceTime(300),
    //     distinctUntilChanged(),
    //   ),
    //   searchString => {
    //     BookingService.searchVenu({
    //       city: this.city,
    //       country: this.country,
    //       search: searchString
    //     }).then(res => {
    //       console.log(res);
    //       this.venues = res.data.venues;
    //     })
    //   }
    // );

    // Promoter Subscription

    this.$subscribeTo(
      this.promoterSearchSubject$
        .asObservable()
        .pipe(debounceTime(300), distinctUntilChanged()),
      (searchString) => {
        BookingService.searchPromoterByName({
          searchString,
        }).then((data) => {
          console.log(data);
          this.promoters = data;
        });
      }
    );

    // Contact Subscription

    this.$subscribeTo(
      this.contactSearchSubject$
        .asObservable()
        .pipe(debounceTime(300), distinctUntilChanged()),
      (searchString) => {
        BookingService.searchContactByName({
          searchString,
        }).then((res) => {
          console.log(res);
          this.contacts = res.data;
        });
      }
    );
  },
  props: {},
  watch: {},
  data: function () {
    return {
      activeTab: "0",
      tabs: [
        { value: 0, text: "Basic Setup" },
        { value: 1, text: "Venue" },
        { value: 2, text: "Promoter" },
        { value: 3, text: "Contact" },
      ],
      cdate: createCDate({}),

      statuses: [],
      countries: [],
      statuses: [],

      venues: [],
      venueSearchSubject$: new Subject(),
      venuSearchString: "",

      promoters: [],
      selectedPromoter: null,
      promoterSearchString: "",
      promoterSearchSubject$: new Subject(),

      contacts: [],
      selectedContact: null,
      contactSearchString: "",
      contactSearchSubject$: new Subject(),

      loading: false,
      customFieldKeys: [],
      bookingData: null,

      finishLocked: false,
      // MARK: data
    };
  },
  computed: {
    calendarDateId: function () {
      return this.$route.params.calendar_date_id;
    },
    artistIdR: function () {
      return this.$route.query.artist_id;
    },

    isBasicTabNextable: function () {
      // return true;
      return this.activeTab == 0; // && this.isBasicFormValid && this.isArtistSelected;
    },

    isVenuTabNextable: function () {
      // return true;
      return this.activeTab == 1; // && this.isvenueFormValid && this.isBasicFormValid && this.isArtistSelected;
    },

    isPromoterTabNextable: function () {
      // console.log('isPromoterTabNextable', this.activeTab, this.selectedPromoter, (this.activeTab == 2 && this.selectedPromoter));
      return this.activeTab == 2 && !isNil(this.selectedPromoter);
    },
    isContactTabTextable: function () {
      return this.activeTab == 3 && this.selectedContact;
    },

    isNextButtonEnabled: function () {
      // return true;
      return any(identity, [
        this.isBasicTabNextable,
        this.isVenuTabNextable,
        this.isPromoterTabNextable,
      ]);
    },
    isBackButtonEnabled: function () {
      return this.activeTab != 0;
    },
    isFinishEnabled: function () {
      // return true;
      return this.selectedPromoter && this.selectedContact;
    },
    isNextTabVisible: function () {
      return this.activeTab < 3;
    },
    isFinishButtonVisible: function () {
      return this.activeTab == 3;
    },
    isBackTabVisible: function () {
      return this.activeTab > 0;
    },

    finishedData: function () {
      return {
        ...createFinishRequest(this.cdate),
        calendar_date_id: this.calendarDateId,
        ...contactToCdatePromoter(this.selectedPromoter),
        ...contactToCDateContact(this.selectedContact),
        ...this.customFieldKeys
          .map((e) => e.cfKey)
          .reduce((accm, cur) => {
            accm[cur] = this.cdate[cur];
            return accm;
          }, {}),
        venue_id: this.cdate.booking_location_id,
        booking_country: this.cdate.venue_country,
        booking_city: this.cdate.venue_city,
        booking_status: this.cdate.booking_status_id,
        contact_label: this.selectedContact.label,
        promoter_id: this.selectedPromoter.promoter_id,
      };
    },
  },
  methods: {
    getCustomFieldKeys: function (cdateObj, bookingCFObj) {
      console.log("CDATE KEYS");
      Object.keys(cdateObj).forEach((key) => {
        if (key.includes("booking_cf_")) {
          const keyString = key.split("_");

          let customField = bookingCFObj.find(
            (e) => e.custom_field_id == keyString[2]
          );
          customField.cfKey = "booking_cf_" + customField["custom_field_id"];
          this.customFieldKeys.push(customField);

          console.log(
            "CDATE KEYS",
            key,
            cdateObj[key],
            bookingCFObj,
            this.customFieldKeys
          );
        }
      });
    },
    onCancelClick: function () {
      this.$emit("cancelled", true);
    },
    onBackClick: function (event) {
      const backTab =
        parseInt(this.activeTab, 10) - 1 < 0
          ? this.tabs.length - 1
          : parseInt(this.activeTab, 10) - 1;
      this.activeTab = `${backTab}`;
    },
    onNextClick: function (event) {
      const nextTab =
        parseInt(this.activeTab, 10) + 1 >= this.tabs.length
          ? 0
          : parseInt(this.activeTab, 10) + 1;

      console.log("NEXT", nextTab);
      if (nextTab == 1) {
        bookingRequestsService.getCustomData(
          this.bookingData.location.booking_location_id,
          "booking_locations"
        );

        bookingRequestsService.getVenueContext(
          this.bookingData.location.booking_location_id,
          this.bookingData.cdate.booking_start_date
        );
      } else if (nextTab == 2) {
      }
      this.changeTab(nextTab);
    },
    changeTab: function (tabNo) {
      this.activeTab = `${tabNo}`;

      if (this.activeTab == 1) {
        // this.initiateVenuTab();
      } else if (this.activeTab == 2) {
        this.initPromoterTab();
      } else if (this.activeTab == 3) {
        this.initContactTab();
      }
    },

    onVenueSearchKeyUp: function (event) {},
    onPromoterSearchKeyUp: function (event) {
      this.searchPromoter(event.target.value);
    },
    searchPromoter: function (searchString) {
      this.promoterSearchString = searchString;
      this.promoterSearchSubject$.next(this.promoterSearchString);
    },
    initPromoterTab: function () {
      this.searchPromoter(this.cdate.promoter_company_name);
    },
    getContactName: function (contact) {
      return contact.first_name
        ? `${contact.first_name} ${contact.last_name}`
        : contact.company_name || contact.company_legalname;
    },
    onNewPromoterClick: function (event) {
      this.selectedPromoter = this.cdatePromoterToContact(this.cdate);
    },
    onSelectPromoter: function (promoter) {
      this.selectedPromoter = promoter;
      bookingRequestsService.getCustomData(
        this.selectedPromoter.promoter_id,
        "promoters"
      );
      bookingRequestsService.getVenueContextPromoter(
        this.selectedPromoter.promoter_id
      );
      console.log("PROMOTER", this.selectedPromoter);
    },
    cdatePromoterToContact: cdatePromoterToContact,
    cdateContactToContact: cdateContactToContact,

    initContactTab: function () {
      this.searchContact(this.cdate.contact_first_name);
    },
    onContactSearchKeyUp: function (event) {
      this.searchContact(event.target.value);
    },
    searchContact: function (searchString) {
      this.contactSearchString = searchString;
      this.contactSearchSubject$.next(this.contactSearchString);
    },
    onSelectContact: function (contact) {
      this.selectedContact = contact;
      bookingRequestsService.getCustomData(
        this.selectedContact.contact_id,
        "contacts"
      );
      console.log("Contact", contact);
    },
    onNewContactClick: function () {
      this.selectedContact = this.cdateContactToContact(this.cdate);
    },

    onBasicInfoChanged: function ({ name, value }) {
      console.log("name, value", name, value);
      this.cdate[name] = value;
    },
    onArtistChange: function (artist, name, value) {
      const artistIndex = this.cdate.artists.findIndex(
        (a) => a.artist_id == artist.artist_id
      );
      // this.$set(this.cdate[artistIndex], name, value);
      // this.cdate.artists[artistIndex][name] = value;
      this.cdate = {
        ...this.cdate,
        artists: this.cdate.artists.map((a) => {
          if (a.artist_id == artist.artist_id) {
            // console.log('matched', a);
            return {
              ...a,
              [name]: value,
            };
          } else {
            return a;
          }
        }),
      };
    },
    onSelectedPromoterChange: function ({ name, value }) {
      this.selectedPromoter = {
        ...this.selectedPromoter,
        [name]: value,
      };
    },
    onSelectedContactChange: function ({ name, value }) {
      this.selectedContact = {
        ...this.selectedContact,
        [name]: value,
      };
    },
    onFinishClick: function (event) {
      this.loading = true;
      if (this.finishLocked) {
        return;
      }
      this.finishLocked = true;
      console.log("FINISH DATA", this.finishedData, this.cdate);
      bookingRequestsService
        .processBookingRequest({
          data: this.finishedData,
        })
        .then((res) => {
          this.loading = false;
          this.$emit("done", true);
        });
      //console.log(this.finishedData);
    },
    // MARK: Methods
  },
};
</script>

<style lang="scss" scoped>
.booking-request {
  .dt-modal--subtitle {
    margin-top: 0px;
    padding-left: 8px;
  }

  .form-group {
    /* padding: 10px; */

    .dt-input-box {
      // margin: 5px 0px;
    }
    .dt-dropdown {
      margin-left: 5px;
      margin-right: 5px;
    }

    .group-input {
      // margin: 10px 0px;
      text-align: left;
    }
  }
}

.box-container {
  // height: calc(100vh - 450px);
}

.tab-content {
  height: 100%;
  overflow: auto;
}

.half-container {
  height: 100%;
  overflow: auto;
}

.artist-side {
  .artist-info {
    margin: 10px 0px;
    &:not(:first-child) {
      margin: 30px 0px;
    }
  }
}

.venues {
  overflow: auto;
  max-height: 500px;

  .venue-item {
  }
}

.venue-search {
  width: 100%;
}

.ab-entity {
  overflow: auto;
  max-height: 500px;

  .ab-entity-item {
  }
}

.ab-entity-search {
  margin-top: 10px;
  width: 100%;
  padding: 0px 5px;
}

.ab-entity-form-container {
  max-height: 500px;

  .layout {
    height: 100%;
  }

  .ab-entity-form-box {
    overflow: auto;

    .ab-entity-form {
    }
  }

  .comment-container {
    height: 40%;
  }
}

// #google-map-element {
//   height: 490px;

//   // transition: 200ms ease-out;

//   &.expanded {
//     position: absolute !important;
//     width: 100%;
//     height: 100%;
//     top: 0px;
//   }
// }

.dt-list-v3 {
  overflow-y: auto;
  height: calc(100% - 95px);
}
</style>